import {ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {provideAnimations} from '@angular/platform-browser/animations';
import {RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module} from 'ng-recaptcha';
import {importProvidersFrom, inject, provideAppInitializer} from '@angular/core';
import {ConfigService} from '@app/_service';
import {ErrorInterceptor, JwtInterceptor, LocaleInterceptor, ProfileInterceptor} from './_helper';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {CustomMatPaginatorIntl} from '@app/_helper/custom-mat-paginator-intl';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi()
    ),

    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ProfileInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: LocaleInterceptor, multi: true},

    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: (config: ConfigService) => config.googleRecaptchaKeySite,
      deps: [ConfigService]
    },

    {provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl},

    provideAppInitializer(() => {
      const initializerFn = ((config: ConfigService) => {
        return () => config.loadConfig();
      })(inject(ConfigService));
      return initializerFn();
    }),

    importProvidersFrom(
      RecaptchaV3Module
    )
  ]
};
